import React from "react";
import { Chip } from "@mui/material";

export type Status =
  | "ATENCAO"
  | "CRITICO"
  | "OK"
  | "null"
  | "inactive"
  | "success"
  | "warning"
  | "danger"
  | "active"
  | "disabled";

interface StatusChipProps {
  status: Status;
  label?: string;
}

const statusStyles: Record<Status, { backgroundColor: string; color: string }> =
  {
    OK: { backgroundColor: "#e6f4ea", color: "#34a853" },
    ATENCAO: { backgroundColor: "#fff8e1", color: "#fbbc04" },
    CRITICO: { backgroundColor: "#fce8e6", color: "#ea4335" },
    null: { backgroundColor: "#f1f3f4", color: "#5f6368" },
    disabled: { backgroundColor: "#f1f3f4", color: "#5f6368" },
    success: { backgroundColor: "#e6f4ea", color: "#34a853" },
    active: { backgroundColor: "#e6f4ea", color: "#34a853" },
    warning: { backgroundColor: "#fff8e1", color: "#fbbc04" },
    inactive: { backgroundColor: "#fce8e6", color: "#ea4335" },
    danger: { backgroundColor: "#fce8e6", color: "#ea4335" },
  };

export const StatusChip: React.FC<StatusChipProps> = ({ status, label }) => {
  const style = statusStyles[status] || statusStyles["null"];
  const parseLabel = (lblStatus: Status, lblCustom?: string) => {
    if (lblCustom) return lblCustom;
    switch (lblStatus) {
      case "ATENCAO":
        return "Atenção";
      case "CRITICO":
        return "Crítico";
      case "OK":
        return "Ok";
      case "active":
        return "Ativo";
      case "warning":
        return "Cópia";
      case "inactive":
        return "Suspenso";
      case "danger":
        return "Perigo";
      default:
        return "-";
    }
  };
  return (
    <Chip
      label={parseLabel(status, label)}
      size="small"
      sx={{
        ...style,
        fontWeight: "bold",
        borderRadius: "16px",
        height: "24px",
      }}
    />
  );
};
